export default "__VITE_ASSET__Cxqri15k__"